<template>
  <tables content='可查询经销商拥有的积分、优惠券、礼品信息' placeholder='请输入经销商名称/编号进行搜索' type='dealer' :columns='columns' ></tables>
</template>
<script>
import tables from './components/tables'
  import { ref } from "vue";
export default {
  components: { tables },
  setup(props) {
    const columns = ref([
      {
        title: "经销商编号",
        dataIndex: "code",
        key: "order_no",
      },
      {
        title: "经销商级别",
        dataIndex: "level_name",
        key: "level_name",
      },
      {
        title: "经销商名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "上级经销商",
        dataIndex: "parent_name",
        key: "parent_name",
      },
      {
        title: "状态",
        dataIndex: "status",
        key: "status",
        slots: { customRender: "status" }
      },
      {
        title: "持有积分",
        dataIndex: "point",
        key: "point",
        align:'center',
        slots: { customRender: "point" }
      },
      {
        title: "持有品牌优惠券",
        dataIndex: "brand_coupon_num",
        key: "brand_coupon_num",
      },
      {
        title: "持有门店优惠券",
        dataIndex: "store_coupon_num",
        key: "store_coupon_num",
      },
      {
        title: "持有礼品",
        dataIndex: "gift_num",
        key: "gift_num",
      },
      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        width:220,
        fixed: "right",
        slots: { customRender: "action" }
      }
    ]);
    return{
      columns
    }
  }
  
}
</script>